const megaByteToByte = (mb: number): number => {

    return mb * 1024 * 1024
};

export default megaByteToByte;
